import { DateTime } from 'luxon';

export const formatLocalTime = (date: Date, format?: string): string =>
  DateTime.fromJSDate(date)
    .setLocale('tr')
    .toFormat(format ?? 'd MMMM yyyy HH:mm');

type DateMatchesOptions = {
  precision?: 'hour' | 'day';
};
export const dateMatches = (
  a: Date,
  b: Date,
  options: DateMatchesOptions = {},
) => {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate() &&
    (options.precision !== 'hour' || a.getHours() === b.getHours())
  );
};
